import { Flex, FlexProps, Progress, Skeleton, Typography } from 'antd';
import React from 'react';

interface WidgetCardProps extends Omit<FlexProps, 'children'> {
  header: React.ReactNode;
  headerExtraContent?: React.ReactNode;
  progressPercent: number;
  metric: React.ReactNode;
}

const ProgressWidget = ({
  header,
  progressPercent,
  metric,
  ...props
}: WidgetCardProps) => {
  const className = `team-progress__widget ${props.className ?? ''}`;
  return (
    <Flex {...props} className={className} vertical gap={12}>
      <Flex justify="space-between" align="center" gap={16} wrap="wrap">
        <Typography.Title
          level={5}
          className="season-overview__widget-text--label"
          ellipsis
        >
          {header}
        </Typography.Title>
      </Flex>
      <Flex vertical gap={1}>
        <Flex
          justify="space-between"
          align="center"
          gap={20}
          wrap="nowrap"
          className="team-progress__widget-text-container"
        >
          <span className="season-overview__widget-text--heading">
            {Math.min(progressPercent || 0, 100)}%
          </span>
          <span className="season-overview__widget-text--helper">{metric}</span>
        </Flex>
        <Progress
          percent={progressPercent}
          showInfo={false}
          type="line"
          strokeColor={'#1677ff'}
        />
      </Flex>
    </Flex>
  );
};

export const ProgressWidgetSkeleton = () => {
  const className = `team-progress__widget`;
  return (
    <Flex className={className} vertical gap={18}>
      <Skeleton.Input active size="small" />
      <Flex vertical gap={3}>
        <Flex justify="space-between" align="center" gap={20}>
          <Skeleton.Button active style={{ width: 30, height: 20 }} />
          <Skeleton.Button active style={{ width: 100, height: 20 }} />
        </Flex>
        <Skeleton
          active
          paragraph={false}
          style={{ height: 10, minHeight: 0 }}
          className="mt-2 rounded-lg"
        />
      </Flex>
    </Flex>
  );
};

export default ProgressWidget;
